import moment from 'moment';
export const formatDate = (dateNum, isDue = false) => {
  if (isDue) {
    return moment(dateNum * 1000).format('YYYY-MM-DD');
  } else {
    return moment(dateNum * 1000).format('YYYY-MM-DD HH:mm:ss');
  }
};
